import CircularProgress from "@mui/material/CircularProgress";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import { DataGrid } from "@mui/x-data-grid";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddCustomer() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  let { type } = useParams();
  const [value, setValue] = useState("1");
  //Variable Global
  const [c_code, setC_code] = useState("");
  const [mac5cod, setMAC5Code] = useState("");
  const [c_ac_no, setC_ac_no] = useState("");
  const [c_name, setC_name] = useState("");
  const [c_limit, setC_limit] = useState("");
  const [c_terms, setC_Terms] = useState("");
  const [c_addr, setC_Addr] = useState("");
  const [c_tel, setC_Tel] = useState("");
  const [c_fax, setC_Fax] = useState("");
  const [c_ContractName, setC_ContractName] = useState("");
  const [c_email, setC_email] = useState("");
  const [c_remark, setC_Remark] = useState("");
  //Factory UseState
  const [Factory, setFactory] = useState();
  const [FoundStatus, setFoundStatus] = useState(false);
  //Add Factory UseState
  const [CreateFactoryName, setCreateFactoryName] = useState("");
  const [CreateFactoryAddress, setCreateFactoryAddress] = useState("");
  const [CreateFactoryPhone, setCreateFactoryPhone] = useState("");
  const [CreateFactoryFax, setCreateFactoryFax] = useState("");
  const [company, setCompany] = useState('');
  const [branch, setBranch] = useState('');
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [companyDataFilter, setCompanyDataFilter] = useState([]);
  const [branchDataFilter, setBranchDataFilter] = useState([]);
  const [FactoryCreateData, setFactoryCreateData] = useState([]);
  const [dataFactory, setDataFactory] = useState([]);
  const [dataFactoryFilter, setDataFactoryFilter] = useState([]);
  const [checkboxSelection, setCheckboxSelection] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [FactorySelectData, setFactorySelectData] = useState([]);

  const classes = useStyles();

  /* table data */
  const columnsFactory = [
    { field: "FactoryName", headerName: "FACTORY NAME", width: 250 },
    { field: "FactoryAddress", headerName: "FACTORY ADDRESS", width: 250 },
    { field: "FactoryMobile", headerName: "FACTORY PHONE", width: 200 },
    {
      field: "Status",
      headerName: "STATUS",
      width: 100,
      valueFormatter: ({ value }) =>
      // console.log(value)
        value === true ? "ACTIVE" : "INACTIVE",
    },
  ];

  //fetch Data
  const getDataFactoryList = async () => {
    try {
      const data = await api.get("api/factory/list");
      // console.log(data);
      setDataFactory(data.data.filter((e) => e.Status === true));
      setDataFactoryFilter(data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataCompanyList = async () => {
    try {
      const res = await api.get("api/master/company");
      setCompanyData(res.data.data.filter((e) => e.Status === true));
      setCompanyDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataBranchList = async () => {
    try {
      const res = await api.get("api/master/branch");
      // console.log(data);
      setBranchData(res.data.data.filter((e) => e.Status === true));
      setBranchDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };

  //Function
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [open, setOpen] = useState(false);
  const [Factoryopen, setFactoryOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickFactoryOpen = () => {
    setFactoryOpen(true);
  };
  const handleFactoryClose = () => {
    setFactoryOpen(false);
  };

  const confirmAddFactory = () => {
    if (
      CreateFactoryName !== "" &&
      CreateFactoryAddress !== "" &&
      CreateFactoryPhone !== "" &&
      CreateFactoryFax !== ""
    ) {
      setOpen(false);
      const check_names = {
        name: CreateFactoryName,
      };

      api
        .post("api/check/name", check_names)
        .then((res) => {
          if (res.data.status) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
              title: "Confirm Save?",
              text: "I agree to save the data!",
              icon: "info",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes !",
            }).then((result) => {
              if (result.isConfirmed) {
                const data = {
                  name: CreateFactoryName,
                  address: CreateFactoryAddress,
                  phone: CreateFactoryPhone,
                  fax: CreateFactoryFax,
                  status: 1,
                  createId: EmpId,
                };
                setFactoryCreateData([...FactoryCreateData, data]);
                setCreateFactoryName("");
                setCreateFactoryAddress("");
                setCreateFactoryPhone("");
                setCreateFactoryFax("");
              }
            });
          }
          if (!res.data.status) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
              icon: "error",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ไม่สำเร็จ!",
                "พบชื่อโรงงานนี้ซ้ำในระบบ กรุณาตรวจสอบอีกครั้ง ! <hr/> ชื่อโรงงาน : " +
                  res.data?.data[0].name +
                  "<br/> ที่อยู่ : " +
                  res.data?.data[0].address +
                  "<br/> เบอร์โทรศัพท์ : " +
                  res.data?.data[0].phone +
                  "<br/> แฟกซ์ : " +
                  res.data?.data[0].fax +
                  "<hr/>",
                "error"
              );
            });
          }
        })
        .catch((err) => {
          const MySwal = withReactContent(Swal);
          MySwal.fire({
            icon: "error",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "ไม่สำเร็จ!",
              "ไม่สามารถเชื่อมต่อกับ Server ได้ !",
              "error"
            );
          });
        });
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };

  useEffect(() => {
    if (value === "1") {

    }
    if (value === "2") {
      getDataFactoryList();
    }
    if (value === "3") {
    }
  }, [value]);
  useEffect(() => {
    getDataBranchList()
    getDataCompanyList()
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          {type == "1" ? "ตัวแทนขนส่งสินค้า" : null}
          {type == "2" ? "ลูกค้า" : null}
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              {type == "1" ? "Forwarder" : null}
              {type == "2" ? "Customer" : null}
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">
              Customer Support / Customer
            </Typography>
            <Typography>
              <span>&nbsp;</span> / Create {type == "1" ? "Forwarder" : null}
              {type == "2" ? "Customer" : null}
            </Typography>
          </Grid>
        </Grid>

        <TabContext value={value}>
          {type == "2" ? (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                variant="scrollable"
                scrollButtons="auto"
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { backgroundColor: "transparent" },
                }}
              >
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Infomation"
                  value="1"
                />

                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Factory"
                  value="2"
                />
{/* 
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Attach file"
                  value="3"
                /> */}
              </TabList>
            </Box>
          ) : null}
          <TabPanel value="1">
            <Formik
              enableReinitialize
              initialValues={{}}
              validate={(values) => {
                const errors = {};
                if (!c_code || c_code === "") {
                  errors.code = "Require";
                }
                if (!c_name || c_name === "") {
                  errors.name = "Require";
                }
                if (!c_ac_no || c_ac_no === "") {
                  errors.accountNo = "Require";
                }

                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  const data = {
                    code: c_code,
                    name: c_name,
                    email: c_email,
                    address: c_addr,
                    contract: c_ContractName,
                    phone: c_tel,
                    fax: c_fax,
                    remark: c_remark,
                    accountNo: c_ac_no,
                    creditLimit: c_limit,
                    creditTerm: c_terms,
                    status: 1,
                    createId: EmpId,
                    type: type,
                    factory: FactorySelectData,
                    newfactory: FactoryCreateData,
                    CompanyId:company || null,
                    BranchId: branch || null
                  };

                  api
                    .post("api/customer/create", data)
                    .then((respose) => {
                      const MySwal = withReactContent(Swal);

                      MySwal.fire({
                        icon: "success",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "สำเร็จ!",
                          "เพิ่มลูกค้าสำเร็จ !",
                          "success"
                        ).then((result) => {
                          if (result.isConfirmed) {
                            history.push("/CustomerSupport/Customer");
                          }
                        });
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                    });

                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                  <h6
                    style={{ marginTop: "10px" }}
                    className="textcolordarkblue"
                  >
                    เพิ่ม {type == "1" ? "ตัวแทนขนส่งสินค้า" : null}
                    {type == "2" ? "ลูกค้า" : null}
                  </h6>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="customer_code"
                          label="Customer Code"
                          variant="outlined"
                          placeholder="Customer Code"
                          onChange={(e) => setC_code(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          classes={{ root: !c_code ? classes.customOutline : null }}
                          value={c_code}
                          required
                        />
                        {/* <TextField
                          name="MAC-5-Code"
                          label="MAC-5 Code"
                          variant="outlined"
                          placeholder="MAC-5 Code"
                          onChange={(e) => setMAC5Code(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          // classes={{ root: !mac5cod ? classes.customOutline : null }}
                          value={mac5cod}
                          // required
                        /> */}

                        <TextField
                          name="account_no"
                          label="MAC-5 Code"
                          variant="outlined"
                          placeholder="MAC-5 Code"
                          onChange={(e) => setC_ac_no(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          // classes={{ root: !c_ac_no ? classes.customOutline : null }}
                          value={c_ac_no}
                          // required
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="customer_name"
                          label="Customer Name"
                          classes={{ root: !c_name ? classes.customOutline : null }}
                          variant="outlined"
                          placeholder="Customer Name"
                          onChange={(e) => setC_name(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_name}
                          required
                        />

                        <TextField
                          name="credit_limit"
                          label="Credit limit"
                          variant="outlined"
                          type="number"
                          inputProps={{
                            maxLength: 13,
                            step: "0.1",
                            min: 1,
                          }}
                          placeholder="Credit limit"
                          onChange={(e) => setC_limit(e.target.value)}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_limit}
                        />

                        <TextField
                          name="credit_term"
                          label="Credit Term (day)"
                          variant="outlined"
                          type="number"
                          inputProps={{
                            maxLength: 13,
                            min: 0,
                          }}
                          placeholder="Credit Term (day)"
                          onChange={(e) => setC_Terms(e.target.value)}
                          style={{ width: "25%" }}
                          InputLabelProps={{ shrink: true }}
                          value={c_terms}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="address"
                          label="Address"
                          variant="outlined"
                          placeholder="Address"
                          onChange={(e) => setC_Addr(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_addr}
                        />

                        <TextField
                          name="telephone"
                          label="Telephone"
                          variant="outlined"
                          placeholder="Telephone"
                          onChange={(e) => setC_Tel(e.target.value)}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_tel}
                        />

                        <TextField
                          name="fax"
                          label="Fax"
                          variant="outlined"
                          placeholder="Fax"
                          onChange={(e) => setC_Fax(e.target.value)}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_fax}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="contract_name"
                          label="Contract Name"
                          variant="outlined"
                          placeholder="Contract Name"
                          onChange={(e) => setC_ContractName(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_ContractName}
                        />

                        <TextField
                          name="email"
                          label="Email"
                          variant="outlined"
                          placeholder="Email"
                          type="email"
                          onChange={(e) => setC_email(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={c_email}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl sx={{ width: "50%", marginRight: '5px'  }}>
                          <InputLabel>Company</InputLabel>
                          <Select
                            name="Company"
                            label="Company"
                            value={company}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setCompany(e.target.value)
                              setBranch('')
                              if(e.target.value){
                                setBranchDataFilter(branchData.filter((item) => item?.CompanyId === e.target.value))
                              } else {
                                setBranchDataFilter(branchData)
                              }
                            }}
                          >
                            <MenuItem value={''}>None</MenuItem>
                            {companyData?.map((item) => {
                              return (
                                <MenuItem value={item?.CompanyId}>{item?.CompanyName}</MenuItem>
                              )
                            })}
                            
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: "50%", marginRight: '5px'  }}>
                          <InputLabel>Branch</InputLabel>
                          <Select
                            name="Branch"
                            label="Branch"
                            value={branch}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => setBranch(e.target.value)}
                          >
                           <MenuItem value={''}>None</MenuItem>
                            {branchDataFilter?.map((item) => {
                              return (
                                <MenuItem value={item?.BranchId}>{item?.BranchName}</MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>

                     
                      </div>
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <TextField
                          fullWidth
                          rows={3}
                          multiline={true}
                          label="Remark "
                          placeholder="Remark"
                          InputLabelProps={{ shrink: true }}
                          name="remark"
                          onChange={(e) => setC_Remark(e.target.value)}
                          value={c_remark}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <CircularProgress size={22} />}
                    {!isSubmitting && "SAVE"}
                  </Button>
                </form>
              )}
            </Formik>
          </TabPanel>
          <TabPanel value="2">
            <div style={{ display: "flex", float: "right" }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickOpen}
              >
                <span className="material-icons-outlined">add</span>
                เพิ่มโรงงานใหม่
              </Button>
            </div>
            <div style={{ display: "flex", float: "right", marginRight: 5 }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickFactoryOpen}
              >
                <span className="material-icons-outlined">add</span>
                เลือกโรงงานในระบบ
              </Button>
            </div>
            <div>
              {selectedRows?.length > 0 ? (
                <TableContainer
                  sx={{
                    marginTop: 5,
                    marginBottom: 2,
                    maxHeight: "50vh",
                    overflow: "auto",
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" width="5%">
                          #
                        </TableCell>
                        <TableCell align="center">ชื่อโรงงาน</TableCell>
                        <TableCell align="center" width="50%">
                          ที่อยู่โรงงาน
                        </TableCell>
                        <TableCell align="center"> </TableCell>
                      </TableRow>
                    </TableHead>
                    {selectedRows?.map((data, index) => {
                      return (
                        <TableBody key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {data.FactoryName}
                          </TableCell>
                          <TableCell align="left" width="50%">
                            {data.FactoryAddress}
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              variant="outlined"
                              style={{
                                color: "#FF0000",
                                borderColor: "#FF0000",
                              }}
                              onClick={() => {
                                selectedRows.splice(index, 1);
                                setSelectedRows([...selectedRows]);
                              }}
                            >
                              ลบ
                            </Button>
                          </TableCell>
                        </TableBody>
                      );
                    })}
                  </Table>
                </TableContainer>
              ) : null}

              {FactoryCreateData?.length > 0 ? (
                <div>
                  <h6
                    style={{ marginTop: "10px" }}
                    className="textcolordarkblue"
                  >
                    {" "}
                    โรงงานสร้างขึ้นใหม่
                  </h6>
                  <TableContainer
                    sx={{
                      marginTop: 2,
                      marginBottom: 2,
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="5%">
                            #
                          </TableCell>
                          <TableCell align="center">ชื่อโรงงาน</TableCell>
                          <TableCell align="center" width="50%">
                            ที่อยู่โรงงาน
                          </TableCell>
                          <TableCell align="center" width="50%">
                            เบอร์โทรศัพท์
                          </TableCell>
                          <TableCell align="center" width="50%">
                            แฟ็กซ์
                          </TableCell>
                          <TableCell align="center"> </TableCell>
                        </TableRow>
                      </TableHead>
                      {FactoryCreateData?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{data.name}</TableCell>
                            <TableCell align="left" width="50%">
                              {data.address}
                            </TableCell>
                            <TableCell align="left" width="50%">
                              {data.phone}
                            </TableCell>
                            <TableCell align="left" width="50%">
                              {data.fax}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                style={{
                                  color: "#FF0000",
                                  borderColor: "#FF0000",
                                }}
                                onClick={() => {
                                  FactoryCreateData.splice(index, 1);
                                  setFactoryCreateData([...FactoryCreateData]);
                                }}
                              >
                                ลบ
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </div>
              ) : null}
            </div>
          </TabPanel>
        </TabContext>
      </Card>

      {/* Modal Add */}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>เพิ่มโรงงาน</DialogTitle>
        <DialogContent>
          <DialogContentText>
            กรุณากรอกข้อมูลให้ครบถ้วนและตรวจสอบก่อน ตกลง .
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="create_fac_name"
            label="ชื่อโรงงาน"
            onChange={(e) => setCreateFactoryName(e.target.value)}
            value={CreateFactoryName}
            fullWidth
            variant="standard"
          />
          <TextField
            margin="dense"
            id="create_fac_addr"
            label="ที่อยู่โรงงาน"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryAddress(e.target.value)}
            value={CreateFactoryAddress}
          />

          <TextField
            margin="dense"
            id="Telephone"
            label="เบอร์โทรศัพท์"
            type="tel"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryPhone(e.target.value)}
            value={CreateFactoryPhone}
          />
          <TextField
            margin="dense"
            id="Fax"
            label="แฟ็กซ์"
            type="tel"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryFax(e.target.value)}
            value={CreateFactoryFax}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={confirmAddFactory}>Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Factoryopen}
        onClose={handleFactoryClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Add Factory</DialogTitle>
        <DialogContent style={{ minHeight: "600px" }}>
          <DialogContentText>
            Please complete the information. and check before confirming .
          </DialogContentText>
          <SearchData name={dataFactory} onsetData={setDataFactoryFilter} />
          <DataGrid
            getRowId={(r) => r.FactoryId}
            pageSize={10}
            rowsPerPageOptions={[10]}
            rows={dataFactoryFilter}
            columns={columnsFactory}
            autoHeight
            checkboxSelection={checkboxSelection}
            selectionModel={selectedRows.map((x) => x.FactoryId)}
            {...dataFactoryFilter}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = dataFactoryFilter.filter((row) =>
                selectedIDs.has(row.FactoryId)
              );
              setSelectedRows(selectedRows);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFactoryClose}>Cancel</Button>
          <Button
            onClick={() => {
              const vari = selectedRows.map((x) => {
                const newData = {
                  facId: x.FactoryId,
                  createId: EmpId,
                };
                return newData;
              });

              setFactorySelectData(vari);
              setFactoryOpen(false);
              // console.log(selectedRows);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
